var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.66666667 L3.43775544e-17,1.33245595 C1.53913554e-17,0.59656085 0.591622194,0 1.33307666,0 L5.33359001,0 C6.06982792,0 6.66666667,0.587946256 6.66666667,1.33245595 L6.66666667,4.66666667 C6.66666667,8 3.33333333,9.33333333 3.33333333,9.33333333 C3.33333333,9.33333333 0,8 0,4.66666667 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#07319C",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1105",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#08B9D6",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-1106",
    stroke: "none",
    fill: "#A63D09",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "3.19744231e-14 6.66666667 6.66666667 6.66666667 6.66666667 9.33333333 4 9.33333333 2.66666667 9.33333333 6.39488462e-14 9.33333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1.33333333 L3.99933333,2.66633333 L5.33333333,2.66666667 L5.33333333,4 L3.99933333,3.99933333 L4,6.66666667 L2.66666667,6.66666667 L2.66633333,3.99933333 L1.33333333,4 L1.33333333,2.66666667 L2.66633333,2.66633333 L2.66666667,1.33333333 L4,1.33333333 Z",
    id: "Rectangle-1106",
    stroke: "none",
    fill: "#262626",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.2968145,-0.578591639 C12.4289261,0.574083174 12.1796848,0.947954902 11.9158002,1.1364439 L11.9158002,1.1364439 L7.66666667,4.1715393 L7.66666667,5.18002169 L15.1566841,11.6000366 L6.57256028,6.33333333 L5.42893208,6.33333333 L-0.333333333,9.93474921 L-0.333333333,8.49512737 L4.33333333,5.16179403 L4.33333333,4.15331164 L-0.901085803,-0.333333333 L0.773488351,-0.333333333 L5.44015502,3 L6.57106792,3 Z",
    id: "Rectangle-36",
    stroke: "#FFFFFF",
    strokeWidth: 0.666666667,
    fill: "#DB1E36",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.33333333 L0,6 L4.66666667,6 L4.66666667,9.33948135 C4.66666667,9.70427573 4.97256724,10 5.33957926,10 L6.66042074,10 C7.0320601,10 7.33333333,9.69934988 7.33333333,9.33948135 L7.33333333,6 L11.9911963,6 C12.3642483,6 12.6666667,5.69409943 12.6666667,5.3270874 L12.6666667,4.00624593 C12.6666667,3.63460657 12.3646425,3.33333333 11.9911963,3.33333333 L7.33333333,3.33333333 L7.33333333,0 L4.66666667,0 L4.66666667,3.33333333 L0,3.33333333 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-36",
    fill: "#DB1E36",
    mask: "url(#mask-2)",
    points: "0 4 5.33333333 4 5.33333333 3.33333333 5.33333333 0 6.66666667 0 6.66666667 3.33333333 6.66666667 4 12 4 12 5.33333333 6.66666667 5.33333333 6.66666667 6 6.66666667 9.33333333 5.33333333 9.33333333 5.33333333 6 5.33333333 5.33333333 0 5.33333333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/MS.0808f519f6d5f291126fd9abe6c547aa.svg";
export { ForwardRef as ReactComponent };